/** XeAgents.ai**/
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, Save } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The page's one primary action.
 *
 * Disabled while anything required is missing, which is only honest because the
 * fields say which and why inline - a dead button with no explanation is the
 * worst of both. The count is on the hint rather than the button so the label
 * never changes shape under the cursor.
 */
export function SaveTemplateButton({
  onSave,
  disabled,
  saving,
  saved,
  size = "default",
  className,
  testId = "button-save-template",
}: {
  onSave: () => void;
  disabled?: boolean;
  saving?: boolean;
  saved?: boolean;
  size?: "default" | "lg";
  className?: string;
  testId?: string;
}) {
  return (
    <Button
      type="button"
      size={size}
      onClick={onSave}
      disabled={disabled || saving || saved}
      className={cn("min-w-[9.5rem]", className)}
      data-testid={testId}
    >
      {saving ? (
        <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Saving...</>
      ) : saved ? (
        <><CheckCircle2 className="mr-2 h-4 w-4" />Saved</>
      ) : (
        <><Save className="mr-2 h-4 w-4" />Save Template</>
      )}
    </Button>
  );
}
